<template>
	<div>
		<div style="overflow:hidden;width:100%;margin:0 auto;min-height:1200px;text-align:center" id="hiddenBox">
			<iframe src="https://biz.hebotc.com/#/companyList" height="1200"
				frameborder="0" width="100%"></iframe>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/company/view.vue